import hreflangs from '../_hreflang/opinie';  
import sortHreflangs from '../_hreflang/sortHrefLangs'; 

export default {
  hrefLang: sortHreflangs(hreflangs, 'pl'),   
  schema: {
    siteName: {
      name: 'Natu.Care',
      url: 'https://natu.care/pl'
    }
  },
  seo: {
    lang: 'pl',
    title: 'Natu.Care: opinie użytkowników',
    description: 'Poznaj opinie klientek i klientów Natu.Care i sprawdź, jak naturalne suplementy pomogły tysiącom zadbać o swoje zdrowie i samopoczucie.'
  },
  genericHeading: {
    heading: 'Wasze opinie - Dlaczego Natu Care działa?',
    // eslint-disable-next-line max-len
    description: 'Opinie i zdjęcia, które od Was dostajemy cieszą nas podwójnie. Przede wszystkim dlatego, że widzimy jak nasze produkty Wam służą, pomagają, poprawiają nastrój i jakość życia.',
    breadcrumbs: [
      {
        label: 'Strona Główna',
        href: '/pl'
      },
      {
        label: 'Opinie'
      }
    ]
  },
  columns: [
    {
      items: [
        {
          variant: 'Vertical',
          color: 'RiseAndShine',
          // eslint-disable-next-line max-len
          quote: '“Dla mnie to numer 1 w smaku, rozpuszcza się o wiele łatwiej niż kolagen, który wcześniej piłam”.',
          name: 'Ewa Grabias',
          productName: 'Kolagen Rise&Shine',
          instagram: {
            label: 'evagiee',
            href: 'https://www.instagram.com/evagiee/'
          },
          picture: {
            xs: '/images/ewa-grabias.jpg',
            alt: 'Ewa Grabias'
          },
          pictureHover: {
            xs: '/images/ewa-grabias-rise-and-shine.jpg',
            alt: 'Ewa Grabias'
          }
        },
        {
          variant: 'Video',
          youtube: {
            id: 'su7oI31B11Y',
            thumbnail: {
              src: '/images/video-cover-2.jpg',
              alt: 'Rise&Shine'
            }
          }
        },
        {
          variant: 'Vertical',
          color: 'GlowStories',
          quote: '“Efekty mówią same za siebie - teraz kocham moje włosy! :)”',
          name: 'Paula Piotrkowska',
          productName: 'Rise&Shine + Glow Stories',
          picture: {
            xs: '/images/paula-piotrowska-2.jpg',
            alt: 'Paula Piotrkowska'
          },
          pictureHover: {
            xs: '/images/paula-piotrowska-rise-and-shine.jpg',
            alt: 'Paula Piotrkowska'
          }
        },
        {
          variant: 'Video',
          youtube: {
            id: 'gJX2gh50_6o',
            thumbnail: {
              src: '/images/video-cover-3.jpg',
              alt: 'video 1 alt'
            }
          }
        },
        {
          variant: 'Vertical',
          color: 'SunnyMood',
          quote: '“Mega wygodna suplementacja.”',
          name: 'Wiktoria Heromińska',
          productName: 'Sunny Mood',
          instagram: {
            label: ''
          },
          picture: {
            xs: '/images/wiktoria-herominska.jpg',
            alt: 'Marta Socik'
          },
          pictureHover: {
            xs: '/images/wiktoria-herominska-sunny-mood.jpg',
            alt: 'Marta Socik'
          }
        },
        {
          variant: 'Vertical',
          color: 'GlowStories',
          quote: '',
          name: 'Magda Konecka',
          productName: 'Glow Stories',
          instagram: {
            label: 'madziaaaa',
            href: 'https://www.instagram.com/madziaaaa/'
          },
          picture: {
            xs: '/images/magda-konecka-2.jpg',
            alt: 'Magda Konecka'
          },
          pictureHover: {
            xs: '/images/magda-konecka-glow-stories.jpg',
            alt: 'Magda Konecka'
          }
        },
        {
          variant: 'Vertical',
          color: 'RiseAndShineLight',
          quote: '"Dla mnie witamina D to codzienna podstawa, lubię to, że jest w kroplach"',
          name: 'Jowita Poklikowska',
          productName: 'Sunny Mood',
          instagram: {
            label: ''
          },
          picture: {
            xs: '/images/jowita-paklikowska.jpg',
            alt: 'Jowita Poklikowska'
          },
          pictureHover: {
            xs: '/images/jowita-paklikowska-sunny-mood.jpg',
            alt: 'Jowita Poklikowska'
          }
        },
        {
          variant: 'Video',
          youtube: {
            id: 'WR3uYjn5JEo',
            thumbnail: {
              src: '/images/video-cover-6.jpg',
              alt: 'Rise&Shine'
            }
          }
        }
      ]
    },
    {
      items: [
        {
          variant: 'Video',
          youtube: {
            id: '-hlMoqBKsxg',
            thumbnail: {
              src: '/images/janek-zdawka.jpg',
              alt: 'Janek Zdawka'
            }
          }
        },
        {
          variant: 'Vertical',
          color: 'RiseAndShineLight',
          quote: '"Zaufałam bo ten kolagen ma świetny skład, no i kocham mango! :) "',
          name: 'Olga Osuch',
          productName: 'Kolagen Rise&Shine',
          instagram: {
            label: 'olgaosuch',
            href: 'https://www.instagram.com/olgaosuch/'
          },
          picture: {
            xs: '/images/olga-osuch.jpg',
            alt: 'Olga Osuch'
          },
          pictureHover: {
            xs: '/images/olga-osuch-rise-and-shine.jpg',
            alt: 'Olga Osuch'
          }
        },
        {
          variant: 'Vertical',
          color: 'RiseAndShine',
          quote: '“Moje selfie nie ma filtra! Nareszcie lubię swoją cerę.”',
          productName: 'Kolagen Cacao Bloom + Glow Stories',
          name: 'Paula Piotrowska',
          picture: {
            xs: '/images/paula-piotrowska-testimonial.jpg',
            alt: 'Paula Piotrowska'
          },
          pictureHover: {
            xs: '/images/paula-piotrowska-cacao-bloom.jpg',
            alt: 'Paula Piotrowska'
          }
        },
        {
          variant: 'Vertical',
          color: 'GlowStories',
          quote: '“Dzięki Wam mam przyjemność z picia kolagenu”',
          name: 'Milena Długosz',
          productName: 'Cacao Bloom',
          instagram: {
            label: 'miladlugosz',
            href: 'https://www.instagram.com/miladlugosz/'
          },
          picture: {
            xs: '/images/mila-dlugosz.jpg',
            alt: 'Mila Długosz'
          },
          pictureHover: {
            xs: '/images/mila-dlugosz-cacao-bloom.jpg',
            alt: 'Mila Długosz'
          }
        },
        {
          variant: 'Vertical',
          color: 'RiseAndShine',
          quote: '"To bez dwóch zdań najsmaczniejszy kolagen jaki suplementowałam"',
          name: 'Magda Zienkiewicz',
          productName: 'Rise&Shine',
          picture: {
            xs: '/images/magda-zienkiewicz.jpg',
            alt: 'Magda Zienkiewicz'
          },
          pictureHover: {
            xs: '/images/magda-zienkiewicz-rise-and-shine.jpg',
            alt: 'Magda Zienkiewicz'
          }
        },
        {
          variant: 'Video',
          video: {
            thumbnail: '/images/video-cover.jpg',
            mp4: 'https://cdn-resources.natu.care/files/wlosy-natu-care.mp4',
            webm: 'https://cdn-resources.natu.care/files/wlosy-natu-care.webm'
          }
        },
        {
          variant: 'Vertical',
          color: 'SleepWell',
          quote: '“Bez problemu wstaje rano z budzikiem, co wcześniej się nie zdarzało, mam więcej energii”',
          name: 'Ewa Szczapinska',
          productName: 'Sleep Well',
          instagram: {
            label: ''
          },
          picture: {
            xs: '/images/ewa-szczapinska.jpg',
            alt: 'Ewa Szczapińska'
          },
          pictureHover: {
            xs: '/images/ewa-szczapinska-sleep-well.jpg',
            alt: 'Ewa Szczapińska'
          }
        },
        // {
        //   variant: 'Image',
        //   color: 'CacaoBloom',
        //   productName: 'Kolagen Cacao Bloom',
        //   picture: {
        //     xs: '/images/anna-kupiec.jpg',
        //     alt: 'Anna Kupiec',
        //     caption: 'Anna Kupiec'
        //   },
        //   pictureHover: {
        //     xs: '/images/anna-kupiec-cacao-bloom.jpg',
        //     alt: 'Anna Kupiec'
        //   }
        // }
      ]
    },
    {
      items: [
        {
          variant: 'Vertical',
          color: 'GlowStories',
          productName: 'Glow Stories + Kolagen Rise&Shine',
          picture: {
            xs: '/images/daria-bosenko-testimonial.jpg',
            alt: 'Daria Bosenko'
          },
          pictureHover: {
            xs: '/images/daria-bosenko-rise-and-shine.jpg',
            alt: 'Daria Bosenko'
          }
        },
        {
          variant: 'Video',
          youtube: {
            id: '9j_lC6fQ2JQ',
            thumbnail: {
              src: '/images/kasia-zurawska.jpg',
              alt: 'Kasia Żurawska'
            }
          }
        },
        {
          variant: 'Image',
          color: 'SleepWell',
          picture: {
            xs: '/images/karolina-kwiatkowska.jpg',
            alt: 'Karolina Kwiatkowska'
          },
          pictureHover: {
            xs: '/images/karolina-kwiatkowska-rise-and-shine.jpg',
            alt: 'Karolina Kwiatkowska'
          }
        },
        {
          variant: 'Video',
          youtube: {
            id: 'Sf6zvOJpX-8',
            thumbnail: {
              src: '/images/video-cover-4.jpg',
              alt: 'Rise&Shine'
            }
          }
        },
        {
          variant: 'Image',
          color: 'SleepWell',
          picture: {
            xs: '/images/oko-sarenki.jpg',
            alt: 'Oko Sarenki'
          },
          pictureHover: {
            xs: '/images/oko-sarenki-caco-bloom.jpg',
            alt: 'Oko Sarenki'
          },
          instagram: {
            href: 'https://www.instagram.com/okosarenki/'
          }
        },
        {
          variant: 'Vertical',
          color: 'GlowStories',
          name: 'Ewa Foryszewska',
          productName: 'Kolagen Rise&Shine + Glow Stories',
          picture: {
            xs: '/images/ewa-foryszewska.jpg',
            alt: 'Ewa Foryszewska'
          },
          pictureHover: {
            xs: '/images/ewa-foryszewska-rise-and-shine.jpg',
            alt: 'Ewa Foryszewska'
          }
        },
        {
          variant: 'Vertical',
          color: 'CacaoBloom',
          quote: '"Nareszcie kolagen, którego efekty widzę w lustrze, i to już po trzecim opakowaniu".',
          name: 'Sylwia Obuchowicz',
          productName: 'Cacao Bloom',
          instagram: {
            label: ''
          },
          picture: {
            xs: '/images/sylwia-obuchowicz.jpg',
            alt: 'Sylwia Obuchowicz'
          },
          pictureHover: {
            xs: '/images/sylwia-obuchowicz-cacao-bloom.jpg',
            alt: 'Sylwia Obuchowicz'
          }
        },
        // {
        //   variant: 'Image',
        //   color: 'SleepWell',
        //   picture: {
        //     xs: '/images/adriana-style.jpg',
        //     alt: 'Adriana Style',
        //     caption: 'adriana-style.com'
        //   },
        //   pictureHover: {
        //     xs: '/images/adriana-style-cacao-bloom.jpg',
        //     alt: 'Adriana Style'
        //   }
        // },
        {
          variant: 'Vertical',
          color: 'CacaoBloom',
          quote: '"Kolagenowe kakao to mój faworyt! :)"',
          name: 'Kasia Kośnik',
          productName: 'Cacao Bloom',
          instagram: {
            label: 'kasia_kosnik',
            href: 'https://www.instagram.com/kasia_kosnik/'
          },
          picture: {
            xs: '/images/kasia-kosnik.jpg',
            alt: 'Kasia Kośnik'
          },
          pictureHover: {
            xs: '/images/kasia-kosnik-cacao-bloom.jpg',
            alt: 'Kasia Kośnik'
          }
        },
        {
          variant: 'Video',
          youtube: {
            id: 'aITW_6xFnlw',
            thumbnail: {
              src: '/images/video-cover-5.jpg',
              alt: 'Rise&Shine'
            }
          }
        },
        {
          variant: 'Image',
          color: 'RiseAndShine',
          productName: 'Rise&Shine i Cacao Bloom',
          picture: {
            xs: '/images/asia-krawczyk.jpg',
            alt: 'Asia Krawczyk',
            caption: 'Asia Krawczyk'
          },
          pictureHover: {
            xs: '/images/asia-krawczyk-rise-and-shhine.jpg',
            alt: 'Asia Krawczyk'
          }
        }
      ],
      columns: []
    }
  ],
  reviews: {
    heading: 'Opinie o produkcie',
    // eslint-disable-next-line max-len
    infoText: 'Nasze opinie są zweryfikowane i pochodzą od Kupujących. W celu zapoznania się z podjętymi środkami weryfikacji opinii odwiedź stronę <a href="https://zaufane.pl/srodki-podjete-w-celu-weryfikacji-opinii">zaufane.pl/dyrektywa-omnibus</a>'
  },
  seal: {
    href: 'https://zaufane.pl/',
    title: 'eKomi gold seal Award',
    image: {
      src: 'https://cdn-resources.natu.care/images/zaufanepl-logo.png',
      alt: 'eKomi gold seal'
    }
  },
  rating: {
    href: 'https://www.ekomi-pl.com/opinie-natu.care.pl.html',
    max: '5',
    title: 'Średnia Ocena'
  },
  numberOfRatings: {
    title: 'Opinie Klientów'
  },
  showMoreButtonText: 'Pokaż więcej'
};
